<template>
  <admin-layout>
    <template v-slot:breadcrumb>
      <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
        <li class="breadcrumb-item text-sm">
          <a class="opacity-5 text-white" href="javascript:;">Pages</a>
        </li>
        <li
          class="breadcrumb-item text-sm text-white active"
          aria-current="page"
        >
          Dashboard
        </li>
      </ol>
    </template>

    <template v-slot:header>
      <h5 class="font-weight-bolder text-white mt-4 mb-0">Dashboard</h5>
    </template>

    <template #content>
      <div class="row">
        <div class="col-lg-3 col-md-6 col-12">
          <div class="mb-4 card">
            <div class="p-3 card-body">
              <div class="d-flex flex-row-reverse justify-content-between mb-4">
                <div>
                  <div
                    class="
                      text-center
                      icon icon-shape
                      bg-gradient-primary
                      border-radius-2xl
                    "
                  >
                    <i
                      class="text-lg opacity-10 ni ni-trophy"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
                <div class="">
                  <div class="numbers">
                    <p class="mb-0 text-sm text-uppercase font-weight-bold">
                      Visualizações esse mês
                    </p>
                    <h5 class="font-weight-bolder">2000</h5>
                    <span class="text-sm text-success"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-12">
          <div class="mb-4 card">
            <div class="p-3 card-body">
              <div class="d-flex flex-row-reverse justify-content-between">
                <div>
                  <div
                    class="
                      text-center
                      icon icon-shape
                      bg-gradient-danger
                      border-radius-2xl
                    "
                  >
                    <i
                      class="text-lg opacity-10 ni ni-like-2"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
                <div class="">
                  <div class="numbers">
                    <p class="mb-0 text-sm text-uppercase font-weight-bold">
                      Você é favorido de
                    </p>
                    <h5 class="font-weight-bolder">60</h5>
                    <span class="text-sm text-success"></span> Pessoas
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-12">
          <div class="mb-4 card">
            <div class="p-3 card-body">
              <div class="d-flex flex-row-reverse justify-content-between mb-4">
                <div>
                  <div
                    class="
                      text-center
                      icon icon-shape
                      bg-gradient-success
                      border-radius-2xl
                    "
                  >
                    <i
                      class="text-lg opacity-10 ni ni-paper-diploma"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
                <div class="">
                  <div class="numbers">
                    <p class="mb-0 text-sm text-uppercase font-weight-bold">
                      Cupons
                    </p>
                    <h5 class="font-weight-bolder">35</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-12">
          <div class="mb-4 card">
            <div class="p-3 card-body">
              <div class="d-flex flex-row-reverse justify-content-between mb-4">
                <div>
                  <div
                    class="
                      text-center
                      icon icon-shape
                      bg-gradient-warning
                      border-radius-2xl
                    "
                  >
                    <i
                      class="text-lg opacity-10 ni ni-single-02"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
                <div class="">
                  <div class="numbers">
                    <p class="mb-0 text-sm text-uppercase font-weight-bold">
                      Usuarios
                    </p>
                    <h5 class="font-weight-bolder">2</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-4">
          <div class="card pb-4">
            <div class="card-header pb-0">
              <div class="row">
                <div class="col-6 d-flex align-items-center">
                  <h6 class="mb-0">Cupons Consumidos</h6>
                </div>
                <div class="col-6 text-end">
                  <button class="btn mb-0 btn-outline-success btn-sm null null">
                    Ver Todos
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body p-3 pb-0 mb-0">
              <ul class="list-group">
                <li
                  class="
                    list-group-item
                    border-0
                    d-flex
                    justify-content-between
                    ps-0
                    mb-2
                    border-radius-lg
                  "
                >
                  <div class="d-flex flex-column">
                    <h6 class="mb-1 text-dark font-weight-bold text-sm">
                      20 de Janeiro de 2023
                    </h6>
                    <span class="text-xs">Paulo Motta Figueiredo</span>
                  </div>
                  <div class="d-flex align-items-center text-sm">
                    20%
                    <button
                      class="btn btn-link text-dark text-sm mb-0 px-0 ms-4"
                    >
                    
                      <i
                        class="fas fa-rocket text-lg me-1"
                        aria-hidden="true"
                      ></i>
                      LINK
                    </button>
                  </div>
                </li>
                <li
                  class="
                    list-group-item
                    border-0
                    d-flex
                    justify-content-between
                    ps-0
                    mb-2
                    border-radius-lg
                  "
                >
                  <div class="d-flex flex-column">
                    <h6 class="mb-1 text-dark font-weight-bold text-sm">
                      25 de Janeiro de 2023
                    </h6>
                    <span class="text-xs">Maria Justina Sebastião</span>
                  </div>
                  <div class="d-flex align-items-center text-sm">
                    15%
                    <button
                      class="btn btn-link text-dark text-sm mb-0 px-0 ms-4"
                    >
                    
                      <i
                        class="fas fa-rocket text-lg me-1"
                        aria-hidden="true"
                      ></i>
                      LINK
                    </button>
                  </div>
                </li>
                <li
                  class="
                    list-group-item
                    border-0
                    d-flex
                    justify-content-between
                    ps-0
                    mb-2
                    border-radius-lg
                  "
                >
                  <div class="d-flex flex-column">
                    <h6 class="mb-1 text-dark font-weight-bold text-sm">
                      26 de Janeiro de 2023
                    </h6>
                    <span class="text-xs">Virgulino Ferreira da Silva</span>
                  </div>
                  <div class="d-flex align-items-center text-sm">
                    30%
                    <button
                      class="btn btn-link text-dark text-sm mb-0 px-0 ms-4"
                    >
                    
                      <i
                        class="fas fa-rocket text-lg me-1"
                        aria-hidden="true"
                      ></i>
                      LINK
                    </button>
                  </div>
                </li>
                <li
                  class="
                    list-group-item
                    border-0
                    d-flex
                    justify-content-between
                    ps-0
                    mb-2
                    border-radius-lg
                  "
                >
                  <div class="d-flex flex-column">
                    <h6 class="mb-1 text-dark font-weight-bold text-sm">
                      27 de Janeiro de 2023
                    </h6>
                    <span class="text-xs">Luiz Inácio Lula da Silva</span>
                  </div>
                  <div class="d-flex align-items-center text-sm">
                    5%
                    <button
                      class="btn btn-link text-dark text-sm mb-0 px-0 ms-4"
                    >
                    
                      <i
                        class="fas fa-rocket text-lg me-1"
                        aria-hidden="true"
                      ></i>
                      LINK
                    </button>
                  </div>
                </li>
                <li
                  class="
                    list-group-item
                    border-0
                    d-flex
                    justify-content-between
                    ps-0
                    mb-2
                    border-radius-lg
                  "
                >
                  <div class="d-flex flex-column">
                    <h6 class="mb-1 text-dark font-weight-bold text-sm">
                      27 de Janeiro de 2023
                    </h6>
                    <span class="text-xs">Jair Messias Bolsonaro </span>
                  </div>
                  <div class="d-flex align-items-center text-sm">
                    35%
                    <button
                      class="btn btn-link text-dark text-sm mb-0 px-0 ms-4"
                    >
                    
                      <i
                        class="fas fa-rocket text-lg me-1"
                        aria-hidden="true"
                      ></i>
                      LINK
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="card mb-2">
            <form action="">
              <div class="card-header pb-0 d-flex">
                <h6>Anotações</h6>

                <button class="btn btn-primary ms-auto">Salvar</button>
              </div>
              <div class="form-group m-3">
                <div class="">
                  <textarea
                    type="textarea"
                    rows="6"
                    max-rows="12"
                    placeholder="Escreve suas anotações aqui, só você pode ver..."
                    class="form-control"
                    name="anotacao"
                  ></textarea>
                </div>
              </div>
            </form>
          </div>
        </div>
adasds
        <div class="col-3">
          <div class="card mb-2">
            <form action="">
              <div class="card-header pb-0 d-flex">
                <h6>Imagens</h6>

                <button class="btn btn-primary ms-auto">Editar</button>
              </div>
              <div class="form-group m-3">
                <carousel :items-to-show="1.5">
                <slide v-for="slide in 5" :key="slide">
                  {{ slide }}
                </slide>

                <template #addons>
                  <navigation />
                  <pagination />
                </template>
              </carousel>
              </div>
            </form>
          </div>
        </div>

        
      </div>
    </template>
  </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

export default {
  components: {
    AdminLayout,
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
};
</script>

